import { Navigate } from "react-router-dom";
import { hasPermission, isAdminLoggedIn } from "../api/adminClient";

export default function ProtectedRoute({ children, permission }) {
  if (!isAdminLoggedIn()) {
    return <Navigate to="/login" replace />;
  }
  if (permission && !hasPermission(permission)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
